/**
 * Question Wall Popup Logic
 * Vanilla JS, ES6, Accessibility Features
 */

document.addEventListener('DOMContentLoaded', () => {
  const popupOverlay = document.getElementById('qw-popup-overlay');
  
  if (!popupOverlay) return; // Exit if no popup on page

  const popupContainer = popupOverlay.querySelector('.qw-popup-container');
  const closeBtn = document.getElementById('qw-popup-close');
  const form = document.getElementById('qw-popup-form');
  const submitBtn = form.querySelector('.qw-btn-submit');
  const msgDiv = document.getElementById('qw-form-msg');
  
  // Find open buttons by class OR by text content containing "drop a question"
  const openBtns = Array.from(document.querySelectorAll('.qw-open-popup-btn'));
  document.querySelectorAll('a, button, .badge').forEach(el => {
    if (el.textContent.toLowerCase().includes('drop a question') && !openBtns.includes(el)) {
      openBtns.push(el);
    }
  });

  let focusableElements = [];
  let firstFocusableElement;
  let lastFocusableElement;

  const getFocusableElements = () => {
    focusableElements = popupContainer.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])');
    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
  };

  const openPopup = (e) => {
    if (e) e.preventDefault();
    popupOverlay.classList.add('qw-is-active');
    popupOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    getFocusableElements();
    if (firstFocusableElement) {
      setTimeout(() => firstFocusableElement.focus(), 100);
    }
  };

  const closePopup = () => {
    popupOverlay.classList.remove('qw-is-active');
    popupOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  // Open triggers
  openBtns.forEach(btn => btn.addEventListener('click', openPopup));

  // Close triggers
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  
  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) {
      closePopup();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popupOverlay.classList.contains('qw-is-active')) {
      closePopup();
    }
    
    // Focus Trap
    if (e.key === 'Tab' && popupOverlay.classList.contains('qw-is-active')) {
      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  });

  // Form Submission
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const endpoint = form.dataset.action;
      if (!endpoint || endpoint.trim() === '') {
        showMessage('Error: Google Apps Script URL is missing.', 'error');
        return;
      }

      // Collect data
      const formData = new FormData(form);
      const data = {};
      
      let isValid = true;

      // Basic client validation loop (fallback for HTML5 validation)
      form.querySelectorAll('input, textarea, select').forEach(input => {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked) {
            // handle multiple checkboxes by appending comma separated
            if (data[input.name]) {
              data[input.name] += ', ' + input.value;
            } else {
              data[input.name] = input.value;
            }
          }
        } else {
          const val = input.value.trim();
          if (input.hasAttribute('required') && !val) {
            isValid = false;
          }
          if (input.name) {
             data[input.name] = val;
          }
        }
      });

      if (!isValid) {
        showMessage('Please fill all required fields.', 'error');
        return;
      }

      // Loading State
      submitBtn.disabled = true;
      submitBtn.classList.add('qw-loading');
      msgDiv.style.display = 'none';

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          }
        });

        let isSuccess = false;
        try {
          const result = await response.json();
          if (result.status === 'success') isSuccess = true;
        } catch (jsonErr) {
          if (response.ok) isSuccess = true;
        }

        if (isSuccess) {
          showMessage(form.dataset.successMsg || 'Success! Your question has been dropped.', 'success');
          form.reset();
          setTimeout(closePopup, 3000);
        } else {
          showMessage(form.dataset.errorMsg || 'An error occurred.', 'error');
        }
      } catch (err) {
        try {
          await fetch(endpoint, {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'text/plain;charset=utf-8'
            }
          });
          showMessage(form.dataset.successMsg || 'Success! Your question has been dropped.', 'success');
          form.reset();
          setTimeout(closePopup, 3000);
        } catch (fallbackErr) {
          showMessage(form.dataset.errorMsg || 'Network error. Please try again.', 'error');
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.classList.remove('qw-loading');
      }
    });
  }

  function showMessage(msg, type) {
    msgDiv.textContent = msg;
    msgDiv.className = 'qw-form-message qw-' + type;
  }
});
